<template>

    <div>

        <div class="py-2 border-bottom">
            <div class="row align-items-center">
                <div class="col-sm-4">
                    <div :style="indent">
                        {{ supplierProperty.name }}
                        ({{ __(':total Produkte', {total: supplierProperty.number_products}) }})
                    </div>
                </div>
                <div class="col-sm-8">
                    <multi-select-input
                        v-model="form.supplier_properties[supplierProperty.id]" 
                        value-consists-of="ALL"
                        :flat="true"
                        sort-value-by="INDEX"
                        :multiple="true" 
                        :options="propertyOptions" 
                        :default-expand-level="1"
                        :placeholder="__('Search properties')"
                        />

                    <div class="invalid-feedback d-block"
                         v-if="form.errors[`supplier_properties.${supplierProperty.id}`]">
                        {{ form.errors[`supplier_properties.${supplierProperty.id}`] }}
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>


<script>

    import MultiSelectInput from '@/shared/Inputs/MultiSelectInput';

    export default {
        name: 'property-nodes',
        props: [
            'form',
            'depth',
            'filters',
            'supplier',
            'properties',
            'supplierProperty',
        ],
        components: {
            MultiSelectInput,
//            PropertyNodes,
        },
        data() {
            return {
                propertyOptions: this.properties,
            }
        },
        watch: {
        },
        methods: {
        },
        computed: {
            indent() {
                return {transform: `translate(${this.depth * 30}px)`}
            }
        }
    }
</script>